import React, { FC } from 'react';
import { STAR_RARITY } from '@wwe-portal/web/utils/superstar-details/constants';

import { Each } from '@wwe-portal/ui/components/utils';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@wwe-portal/ui/components/dropdown/dropdown-menu';
import { ClickableDiv } from '@wwe-portal/ui/components/button/clickable-div';
import { cn } from '@wwe-portal/ui/lib/lib';
import RarityStars from './RarityStars';
import { IcoMoonIcon } from '../../../../../packages/ui/components/icons';

interface RarityMenuProps {
  wrestlerTier: string;
  starRarity: string;
  starRarityDropdownItemClick: (level: string) => void;
  className?: string;
}

const RarityMenu: FC<RarityMenuProps> = ({
  wrestlerTier,
  starRarity,
  starRarityDropdownItemClick,
  className,
}) => {
  const [isOpen, setIsOpen] = React.useState(false);
  return (
    <DropdownMenu onOpenChange={() => setIsOpen((isOpen) => !isOpen)}>
      <DropdownMenuTrigger asChild>
        <ClickableDiv
          className={cn(
            'border-back200 bg-back300 text-textColor15 drop-shadow-card flex h-[46px] w-full items-center justify-between rounded border-0 border-l-[1px] border-solid px-5 py-2.5 text-center text-sm font-medium',
            className
          )}
        >
          <RarityStars
            level={starRarity}
            className={cn('size-5', {
              'text-[#cd7f32]': wrestlerTier === 'Bronze',
              'text-[#d3d3d3]': wrestlerTier === 'Silver',
              'text-[gold]': wrestlerTier === 'Gold',
            })}
          />
          <IcoMoonIcon
            iconName="arrow"
            className={cn(
              'text-inlineTextColor18 size-4 transition-transform',
              {
                'rotate-180': isOpen,
              }
            )}
          />
        </ClickableDiv>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align={'start'}
        isQualMenuWidth={true}
        className="bg-back200 text-textColor15"
        onCloseAutoFocus={(event) => {
          event.preventDefault();
        }}
      >
        <div className="no-scrollbar pointer-events-auto max-h-[360px] overflow-y-auto">
          <Each
            data={STAR_RARITY}
            render={(level) => (
              <DropdownMenuItem
                className={cn(
                  'hover:bg-back300 cursor-pointer rounded-xl px-2 capitalize'
                )}
                onClick={() => starRarityDropdownItemClick(level)}
                key={level}
              >
                <RarityStars level={level} />
              </DropdownMenuItem>
            )}
          />
        </div>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
export default RarityMenu;
